export class Auth {
	
	login(parent)
	{
		var form = $(parent);
		form.find('*[type=submit]').attr('disabled', true);
		
		$.ajax({
			url: "/ajax.php?mid=12",
			type: 'POST',
			data: form.serialize(),
			dataType: "json",
			success: function(res){
				form.find('*[type=submit]').attr('disabled', false);
				
				if (res['success'])
				{
					form.find('.form__mistakes').text('').hide();
					location.reload();
				}
				else 
				{
					form.find('.form__mistakes').text(res['error']).show();
				}
			},
			error: function(res){
				form.find('*[type=submit]').attr('disabled', false);
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}			
		});
	}

	recallPassword(parent){
		var form = $(parent);
		form.find('*[type=submit]').attr('disabled', true);
		var formData = form.serialize();

		// Custom data to be added
		var customData = {
			action: 'forget'
		};

		// Combine form data and custom data
		var combinedData = formData + '&' + $.param(customData);
		$.ajax({
			url: "/ajax.php?mid=12",
			data: combinedData,
			type: 'POST',
			dataType: "json",
			success: function(res){
				form.find('*[type=submit]').attr('disabled', false);
				
				if (res['success'])
				{
					form.find(".form__main").hide();
					form.find(".form__mistakes").text('').hide();
					form.find(".form__success").show();
				}
				else 
				{
					form.find(".form__mistakes").text(res['error']).show();
					form.find(".form__success").hide();
				}
			},
			error: function(res){
				form.find(".form__mistakes").text(res['error']).show();
				form.find(".form__success").hide();
			}			
		});
	}
}